import http from '@/api/HttpHelper'

const state = {
    reportTypes: []
}

const getters = {
    reportTypes (state) {
        return state.reportTypes
    }
}

const mutations = {
    setReportTypes (state, reportTypes) {
        state.reportTypes = reportTypes
    }
}

const actions = {
    async getReportTypes ({ commit }) {
        var result = await http.get('productmapping/reporttypes')
        commit('setReportTypes', result.data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}